import moment from 'moment';
import React from 'react';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { connect } from 'react-redux';
import { Row, Col, Icon, Spin } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

import { groupBy } from '../../util'
import{ ITEMS_EVERY_PAGE } from '../../conf'
import { fetchTxInfo, fetchTxDetail } from '../../redux/modules/tx';

const COIN = 100000000;

function toNonExponential(num) {
    var m = num.toExponential().match(/\d(?:\.(\d*))?e([+-]\d+)/);
    return num.toFixed(Math.max(0, (m[1] || '').length - m[2]));
}
class Tx extends React.Component {
    constructor(props){
        super(props);
    }
    
    getContractInfo(outputs) {
        return outputs.map(output => {
            switch (output.scriptPubKey.type) {
                case 'evm_create':
                case 'evm_create_sender':
                    return {type: 'create'}
                case 'evm_call':
                case 'evm_call_sender':
                    return {type: 'call'}
                default:
                    return null
            }
        })
    }
    
    componentDidMount() {
        var hash = this.props.match.params.hash;
        this.props.onFetchTxInfo(hash);
    }
    componentDidUpdate(prevProps) {
        const hash = this.props.match.params.hash
        if (prevProps.match.params.hash !== this.props.match.params.hash){
            this.props.onFetchTxInfo(hash);
        }
    }
    componentWillUnmount() {
        //clearInterval(this.interval);
    }
    render() {
        const { txInfo, txInfoLoading } = this.props;

        //this.combineVinAndVout(vins, vouts);

        let feeRate = txInfo.fee > 0?(txInfo.fee/txInfo.size).toFixed(2):0;
        let outputs = txInfo.outputs;
        let inputs = txInfo.inputs;
        let contractSpends = txInfo.contractSpends;
        let qrc20TokenTransfers = txInfo.qrc20TokenTransfers;

        let contractInfo = this.getContractInfo(outputs);

        let receipts = outputs.map(output => output.receipt).filter(Boolean)

        // let voucherInputs = txInfo.voucherInputs;
        // let voucherOutputs = txInfo.voucherOutputs;
        // let voucherInputsMap = groupBy(voucherInputs, 'address');
        // let voucherOutputsMap = groupBy(voucherOutputs, 'address');

        return (
            <div className="container">
                <Spin spinning={txInfoLoading}>
                <div className="page-header">
                    <h1><FormattedMessage id="transaction.transaction" /></h1>
                    <div className="block-hash"><em><FormattedMessage id="transaction.hash" /></em> {txInfo.hash}</div>
                </div>
                <div className="address-wrap">
                    <div className="block-summary">
                        <h2><FormattedMessage id="transaction.summary" /></h2>
                        <div className="block-summary-content">
                            {/* <div className="block-summary-item">
                                <div className="block-summary-item-label"><FormattedMessage id="transaction.type" /></div>
                                <div className="block-summary-item-value">{txInfo.flag==1?<FormattedMessage id="transaction.vid_tx" /> : <FormattedMessage id="transaction.normal_tx" />}</div>
                            </div> */}
                            <div className="block-summary-item">
                                <div className="block-summary-item-label"><FormattedMessage id="transaction.size" /></div>
                                <div className="block-summary-item-value">{txInfo.size} (bytes)</div>
                            </div>
                            <div className="block-summary-item">
                                <div className="block-summary-item-label"><FormattedMessage id="transaction.fee_rate" /></div>
                                <div className="block-summary-item-value">{feeRate} sats/byte</div>
                            </div>
                            <div className="block-summary-item" >
                                <div className="block-summary-item-label"><FormattedMessage id="transaction.confirmations" /></div>
                                <div className="block-summary-item-value">{txInfo.confirmations}</div>
                            </div>
                            <div className="block-summary-item">
                                <div className="block-summary-item-label"><FormattedMessage id="transaction.time" /></div>
                                <div className="block-summary-item-value">{moment(new Date(txInfo.timestamp*1000)).format('YYYY-MM-DD HH:mm:ss')}</div>
                            </div>
                            <div className="block-summary-item">
                                <div className="block-summary-item-label"><FormattedMessage id="transaction.included_in_block" /></div>
                                <div className="block-summary-item-value">
                                    <Link to={`/block/${txInfo.blockHash}`}>{txInfo.blockHeight}</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="block-txs">
                        <h2><FormattedMessage id="transaction.details" /></h2>
                        <div className="tx-item">
                            <div className="tx-detail">
                                <Row type="flex" justify="space-between">
                                    <Col span={10}>
                                        {txInfo.isCoinbase ? (
                                            <div className="tx-detail-list">
                                                <div className="tx-detail-item">
                                                    <div className="tx-detail-item-label">No Inputs (Newly Generated Coins)</div>
                                                </div>
                                            </div>
                                        ) : (
                                            txInfo.inputs.length == 0?
                                            <div className="tx-detail-list">
                                                <div className="tx-detail-item">
                                                    <div className="tx-detail-item-label">No Inputs (Anonymous Coins)</div>
                                                </div>
                                            </div>
                                            :
                                            <div className="tx-detail-list">
                                                {txInfo.inputs.map((vin, index) => {
                                                    let html = <div className="tx-detail-item" key={vin.prevTxId+vin.outputIndex}>
                                                        <div className="tx-detail-item-label">
                                                            {
                                                                vin.address.length == 40 ?
                                                                    <Link to={`/contract/${vin.address}`}>{vin.address}</Link>
                                                                    :
                                                                    <Link to={`/address/${vin.address}`}>{vin.address}</Link>
                                                            }
                                                        </div>
                                                        <div className="tx-detail-item-value">{parseFloat((vin.value/Math.pow(10, 8)).toFixed(8))} Vollar</div>
                                                    </div>
                                                    return html;
                                                })}
                                            </div>
                                            
                                        )}
                                        
                                    </Col>
                                    <Col span={2}>
                                        <div className="tx-detail-arrow">
                                            <ArrowRightOutlined />
                                        </div>
                                    </Col>
                                    <Col span={12}>
                                        <div className="tx-detail-list">
                                            {
                                                outputs.length == 0?
                                                <div className="tx-detail-list">
                                                    <div className="tx-detail-item">
                                                        <div className="tx-detail-item-label">No Outputs (Anonymous Coins)</div>
                                                    </div>
                                                </div>
                                                :
                                                outputs.map((vout, index) => {
                                                    let html = <div className="tx-detail-item" key={vout.address+index}>
                                                        <div className="tx-detail-item-label">
                                                            {
                                                                vout.address.length == 40 ?
                                                                    <Link to={`/contract/${vout.address}`}>{vout.address}</Link>
                                                                    :
                                                                    <Link to={`/address/${vout.address}`}>{vout.address}</Link>
                                                            }
                                                            
                                                        </div>
                                                        {contractInfo[index]?
                                                        <div className="tx-detail-item-value">
                                                            {
                                                                contractInfo[index].type == 'create' && <FormattedMessage id="transaction.contract_type_create" />
                                                            }
                                                            {
                                                                contractInfo[index].type == 'call' && <FormattedMessage id="transaction.contract_type_call" />
                                                            }
                                                        </div>
                                                        :
                                                        <div className="tx-detail-item-value">
                                                            {parseFloat((vout.value/Math.pow(10, 8)).toFixed(8))} Vollar
                                                        </div>
                                                        }
                                                    </div>
                                                    return html;
                                                })
                                            }
                                        </div>
                                    </Col>
                                </Row>
                            </div>

                            { txInfo.refundValue > 0 && <div className="tx-detail mt-20">
                                <Row type="flex" justify="space-between">
                                    <Col span={10}>
                                        <div className="tx-detail-list">
                                            <div className="tx-detail-item">
                                                <div className="tx-detail-item-label"><FormattedMessage id="transaction.gas_refund" /></div>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col span={2}>
                                        <div className="tx-detail-arrow">
                                            <ArrowRightOutlined />
                                        </div>
                                    </Col>
                                    <Col span={12}>
                                        <div className="tx-detail-list">
                                            <div className="tx-detail-item">
                                                <div className="tx-detail-item-label">
                                                    <Link to={`/address/${inputs[0].address}`}>{inputs[0].address}</Link>
                                                </div>
                                                <div className="tx-detail-item-value">
                                                    {parseFloat((txInfo.refundValue/Math.pow(10, 8)).toFixed(8))} Vollar
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            }

                            { contractSpends && contractSpends.length > 0 && <div className="tx-detail mt-20">
                                {
                                    contractSpends.map((contractSpend, index) => {
                                        let html = <Row type="flex" justify="space-between" key={index}>
                                            <Col span={10}>
                                                <div className="tx-detail-list">
                                                    {contractSpend.inputs.map((vin, index) => {
                                                        let html = vin.address?<div className="tx-detail-item" key={vin.address}>
                                                            <div className="tx-detail-item-label">
                                                                {
                                                                    vin.address.length == 40 ?
                                                                    <Link to={`/contract/${vin.address}`}>{vin.address}</Link>
                                                                    :
                                                                    <Link to={`/address/${vin.address}`}>{vin.address}</Link>
                                                                }
                                                            </div>
                                                            <div className="tx-detail-item-value">
                                                                {parseFloat((vin.value/Math.pow(10, 8)).toFixed(8))} Vollar
                                                            </div>
                                                        </div>
                                                        :
                                                        <div className="tx-detail-item" key={vin.addressHex}>
                                                            <div className="tx-detail-item-label">
                                                                {
                                                                    vin.addressHex.length == 40 ?
                                                                    <Link to={`/contract/${vin.addressHex}`}>{vin.addressHex}</Link>
                                                                    :
                                                                    <Link to={`/address/${vin.addressHex}`}>{vin.addressHex}</Link>
                                                                }
                                                            </div>
                                                            <div className="tx-detail-item-value">
                                                                {parseFloat((vin.value/Math.pow(10, 8)).toFixed(8))} Vollar
                                                            </div>
                                                        </div>
                                                        return html;
                                                    })}
                                                </div>
                                            </Col>
                                            <Col span={2}>
                                                <div className="tx-detail-arrow">
                                                    <ArrowRightOutlined />
                                                </div>
                                            </Col>
                                            <Col span={12}>
                                                <div className="tx-detail-list">
                                                    {contractSpend.outputs.map((vout, index) => {
                                                            let html = <div className="tx-detail-item" key={vout.address}>
                                                                <div className="tx-detail-item-label">
                                                                    {
                                                                        vout.address.length == 40 ?
                                                                        <Link to={`/contract/${vout.address}`}>{vout.address}</Link>
                                                                        :
                                                                        <Link to={`/address/${vout.address}`}>{vout.address}</Link>
                                                                    }
                                                                </div>
                                                                <div className="tx-detail-item-value">
                                                                    {parseFloat((vout.value/Math.pow(10, 8)).toFixed(8))} Vollar
                                                                </div>
                                                            </div>
                                                            return html;
                                                        })
                                                    }
                                                </div>
                                            </Col>
                                        </Row>
                                        return html;
                                    }
                                        
                                    )
                                }
                            </div>
                            }

                            { qrc20TokenTransfers && qrc20TokenTransfers.length > 0 && <div className="tx-detail mt-20">
                                {
                                    qrc20TokenTransfers.map((qrc20TokenTransfer, index) => {
                                        let html = <Row type="flex" justify="space-between" key={index}>
                                            <Col span={10}>
                                                <div className="tx-detail-list">
                                                    <div className="tx-detail-item">
                                                        <div className="tx-detail-item-label">
                                                            {
                                                                qrc20TokenTransfer.from.length == 40 ?
                                                                <Link to={`/contract/${qrc20TokenTransfer.from}`}>{qrc20TokenTransfer.from}</Link>
                                                                :
                                                                <Link to={`/address/${qrc20TokenTransfer.from}`}>{qrc20TokenTransfer.from}</Link>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col span={2}>
                                                <div className="tx-detail-arrow">
                                                    <ArrowRightOutlined />
                                                </div>
                                            </Col>
                                            <Col span={12}>
                                                <div className="tx-detail-list">
                                                    <div className="tx-detail-item">
                                                        <div className="tx-detail-item-label">
                                                            {
                                                                qrc20TokenTransfer.to.length == 40 ?
                                                                <Link to={`/contract/${qrc20TokenTransfer.to}`}>{qrc20TokenTransfer.to}</Link>
                                                                :
                                                                <Link to={`/address/${qrc20TokenTransfer.to}`}>{qrc20TokenTransfer.to}</Link>
                                                            }
                                                        </div>
                                                        <div className="tx-detail-item-value">
                                                            {parseFloat((qrc20TokenTransfer.value/Math.pow(10, 8)).toFixed(8))} {qrc20TokenTransfer.symbol}
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                        return html;
                                    }
                                        
                                    )
                                }
                            </div>
                            }


                            { receipts && receipts.length > 0 && <div className="tx-detail mt-20">
                                {
                                    receipts.map((receipt, index) => 
                                        <div className="tx-receipt" key={index}>
                                            <Row type="flex">
                                                <Col span={10}>
                                                    <div className="tx-receipt-name">
                                                        <FormattedMessage id="contract.sender" />
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="tx-receipt-value">
                                                        <Link to={`/address/${receipt.sender}`}>{receipt.sender}</Link>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row type="flex">
                                                <Col span={10}>
                                                    <div className="tx-receipt-name">
                                                        <FormattedMessage id="token.contract_address" />
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="tx-receipt-value">
                                                        <Link to={`/contract/${receipt.contractAddress}`}>{receipt.contractAddress}</Link>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row type="flex">
                                                <Col span={10}>
                                                    <div className="tx-receipt-name">
                                                        <FormattedMessage id="contract.gasUsed" />
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="tx-receipt-value">
                                                        {receipt.gasUsed}
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                        
                                    )
                                }
                            </div>
                            }

                            <div className="tx-expand tx-expand-flex">
                                <div className="tx-expand-left">
                                    <span className="tx-tag tx-fee">FEE: {txInfo.fees>0?parseFloat((txInfo.fees/Math.pow(10, 8)).toFixed(8)):0} VOLLAR</span>
                                </div>
                                <div className="tx-expand-right">
                                    {
                                        txInfo.confirmations == -3 &&
                                        <span className="tx-tag tx-danger">Invalid</span>
                                    }
                                    {
                                        txInfo.confirmations == -1 &&
                                        <span className="tx-tag tx-unconfirmd">Unconfirmed</span>
                                    }
                                    {
                                        txInfo.confirmations == 1 &&
                                        <span className="tx-tag tx-confirms">{txInfo.confirmations} Confirmation</span>
                                    }
                                    {
                                        txInfo.confirmations > 1 &&
                                        <span className="tx-tag tx-confirms">{txInfo.confirmations} Confirmations</span>
                                    }
                                    <span className="tx-tag tx-value">{parseFloat((txInfo.outputValue/Math.pow(10, 8)).toFixed(8))} VOLLAR</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* { voucherOutputs && voucherOutputs.length > 0 && <div className="block-txs">
                        <h2><FormattedMessage id="transaction.voucher" /></h2>
                        <div className="tx-item">
                            <div className="tx-detail">
                            <Row type="flex" justify="space-between">
                                <Col span={10}>
                                    { voucherInputs.length == 0?
                                    <div className="tx-detail-list">
                                        <div className="tx-detail-item">
                                            <div className="tx-detail-item-label"><FormattedMessage id="transaction.new_generated" /></div>
                                        </div>
                                    </div>
                                    :
                                    <div className="tx-detail-list">
                                         
                                        {Object.keys(voucherInputsMap).map((address, index) => {
                                            let voucherInput = voucherInputsMap[address];
                                            let html = <div className="tx-detail-item" key={address}>
                                                <div className="tx-detail-item-label">
                                                    {
                                                        address.length == 40 ?
                                                            <Link to={`/contract/${address}`}>{address}</Link>
                                                            :
                                                            <Link to={`/address/${address}`}>{address}</Link>
                                                    }
                                                </div>
                                            </div>
                                            return html;
                                        })}
                                    </div>
                                    }
                                </Col>
                                <Col span={2}>
                                    <div className="tx-detail-arrow">
                                        <ArrowRightOutlined />
                                    </div>
                                </Col>
                                <Col span={12}>
                                    <div className="tx-detail-list">
                                    {
                                        Object.keys(voucherOutputsMap).map((address, index) => {
                                            let voucherOutput = voucherOutputsMap[address];
                                            let html = <div className="tx-detail-item" key={address}>
                                                <div className="tx-detail-item-label">
                                                    {
                                                        address.length == 40 ?
                                                            <Link to={`/contract/${address}`}>{address}</Link>
                                                            :
                                                            <Link to={`/address/${address}`}>{address}</Link>
                                                    }
                                                    
                                                </div>
                                                
                                                <div className="tx-detail-item-value">
                                                    {voucherOutput.length} 个
                                                </div>
                                                
                                            </div>
                                            return html;
                                        })
                                    }
                                    </div>
                                </Col>
                            </Row>
                            </div>
                        </div>
                    </div>
                    } */}
                </div>
                </Spin>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return{
        newestBlock: state.getIn(['block', 'newestBlock']).toJS(),
        txInfo: state.getIn(['tx', 'info']).toJS(),
        txDetail: state.getIn(['tx', 'detail']).toJS(),
        txInfoLoading: state.getIn(['tx', 'txInfoLoading'])
    }
 }
const mapDispatchToProps = (dispatch) => {
    return{
        onFetchTxInfo: (hash) => {
            dispatch(fetchTxInfo(hash))
        },
        onFetchTxDetail: (hash) => {
            dispatch(fetchTxDetail(hash))
        }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Tx);
